import {
  FDHeadlineText, FDImage, FDStack,
} from '@facet-wealth/design';
import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import useMobileLayout from 'Hooks/useMobileLayout';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { Carousel } from 'Packages/FacetDesign/Components/Experimental/Carousel';
import { BorderedTransparentBox } from 'Packages/FacetDesign/Components/Experimental/BorderedTransparentBox';
import { PersonalizedOutcomeDataCard } from './PersonalizedOutcomeDataCard';

const metaOverrides = buildFacetDesignOverride()
  .nameOverride(['title'], {
    _component: () => FDHeadlineText,
    _customProps: { size: 'lg', align: 'center' },
  }, overrideReadOnly);

export const PersonalizedOutcomeData = ({ resource }) => {
  const isMobile = useMobileLayout();

  const items = resource.attr('data')?.resources()?.list();
  const hasItems = items?.length > 0;
  if (!hasItems) { // if there are no items, hide the section
    return null;
  }

  const WrapperComponent = isMobile ? React.Fragment : BorderedTransparentBox;
  const wrapperProps = isMobile ? {} : {
    padding: 4,
    color: 'info',
    width: '100%',
  };
  return (
    <WrapperComponent {...wrapperProps}>
      <FDStack direction={'column'} spacing={4} alignItems={'center'}>
        {resource.withRelationship(fr.relationships.image.name,
          (rel) => <FDImage alt={''} src={rel.link('related').url()} rounded={false} />,
          () => null)}
        <MetaControl attrName={'title'} resource={resource} metaOverrideSet={metaOverrides} />
        <Carousel maxCardsVisible={isMobile ? 1.1 : 3.1}>
          {hasItems && resource.attr('data')?.resources().list().map((d) => <PersonalizedOutcomeDataCard key={d.id()} resource={d} />)}
        </Carousel>
      </FDStack>
    </WrapperComponent>
  );
};

PersonalizedOutcomeData.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
